import { _ep5, _mw5, command } from "../commandBuilder";
import { PutObjectTagging$ } from "../schemas/schemas_0";
export class PutObjectTaggingCommand extends command(_ep5, _mw5, "PutObjectTagging", PutObjectTagging$) {
}
